import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ControlsOf } from '../../shared/utils/controls-of';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective } from 'ngx-mask';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Ssin } from '@smals/ngx-smalsutils-validation';
import { MatIconModule } from '@angular/material/icon';

interface DialogData {
  ssin: string
}

@Component({
  selector: 'app-no-ssin-dialog',
  templateUrl: './ssin-dialog.component.html',
  styleUrls: ['./ssin-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, NgxMaskDirective, TranslateModule, MatIconModule]
})
export class SsinDialogComponent {
  dialogDataForm: FormGroup<ControlsOf<DialogData>>;

  constructor(
    private dialog: MatDialogRef<SsinDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { isLogout: boolean }
  ) {
    this.dialogDataForm = this.fb.nonNullable.group({
      ssin: [
        '',
        [
          Validators.required, Ssin.checkPattern
        ]
      ]
    });
  }

  onConfirm(): void {
    this.dialog.close({ssin: this.dialogDataForm.get('ssin').value});
  }

  onDropID(event: DragEvent): void {
    event.dataTransfer.dropEffect = 'copy';
    event.preventDefault();

    const xmlData = event.dataTransfer.getData('text');
    const ssin = this.parseDataEIDViewer(xmlData);

    this.dialogDataForm.get('ssin').setValue(ssin);
  }

  private parseDataEIDViewer(data: string): string {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, 'text/xml');

    return xmlDoc.getElementsByTagName('identity')[0]?.attributes['nationalnumber'].nodeValue;
  }

}

